import z from "zod"
import { CreatePartnerRequest } from "../auth"

export const CreatePartnerInputSchema = CreatePartnerRequest.merge(
  z.object({
    referralPromotionCode: z.string().optional(),
    stripeSetupIntentId: z.string().startsWith('seti_').optional(),
  }),
)
export type CreatePartnerInput = z.infer<typeof CreatePartnerInputSchema>

export const CreatePartnerOutputSchema = z.object({
  userId: z.string().uuid(),
})
export type CreatePartnerOutput = z.infer<typeof CreatePartnerOutputSchema>
